import { rtkanalyzer } from '@/http.js';

const USE_MOCK = false; // set false for prod

const MOCK_RESPONSE = {
  status: 'COMPLETED',
  completionPercentage: 100,
  result: {
    globalScore: 0.7590293082591005,
    level: 'good',
    subScores: {
      msmPrecision: 1.0,
      constellationScore: 1.0,
      frequencyScore: 0.0,
      signalStrengthScore: 0.31670515781370295,
      metadataPresence: 1.0,
      streamStability: 0.9965,
      clockConsistency: 1.0,
    },
    rawMeasures: {
      msm47Count: 71,
      totalMsmCount: 71,
      gpsSatelliteCount: 9,
      glonassSatelliteCount: 0,
      galileoSatelliteCount: 9,
      beidouSatelliteCount: 10,
      sbasSatelliteCount: 0,
      qzssSatelliteCount: 0,
      totalSatelliteCount: 28,
      averageSignalNoiseRatioInDb: 34.750577367205544,
      averageFrequencyInHz: 0.9658169776827291,
      averageMessageIntervalMillis: 1035,
      totalUptimeMillis: 29895,
      observationPeriodSeconds: 30,
      hasMetadata: true,
      majorConstellationCount: 3,
      additionalMeasures: {},
    },
  },
  error: null,
};

class RtkAnalyzerService {
  evaluate(mountpoint) {
    if (USE_MOCK) {
      return new Promise((resolve) =>
        setTimeout(() => resolve({ data: MOCK_RESPONSE }), 1200)
      );
    }
    return rtkanalyzer.get(`/rtk-eval/${mountpoint}`);
  }
}

export default new RtkAnalyzerService();
